import React from 'react';
import PropTypes from 'prop-types';

import Total from '../Display/Total';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';

import PublicIcon from 'material-ui/svg-icons/action/lock-open';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import RegistrationHistory from '../Module/RegistrationHistory';

const EnrolmentSegment = ({enrolment, course, modules, actions, subscription}) => {

    let subtitle = '';
    let score = 0;

    let iconProps = {
        color: 'rgba(117, 117, 117 ,0.7)',
    };

    if (!!enrolment.id) {

        const enrolmentMethod = (enrolment.isAssigned ? 'Assigned' : 'Booked' );

        switch (enrolment.status) {

            case 'waiting':
                subtitle = 'On waiting list';
                break;

            case 'enrolled':
                subtitle = enrolmentMethod;

                score = Number(enrolment.score);

                if (!!enrolment.dateStart) {
                    const enrolmentDate = new Date(enrolment.dateStart);
                    if (!!enrolmentDate && !isNaN(enrolmentDate.valueOf())) {
                        subtitle += ` on ${enrolmentDate.toDateString()}`;
                    }
                }

                break;

            case 'completed':

                subtitle = 'Completed';
                score = Number(enrolment.score);

                if (!!enrolment.dateCompleted) {
                    const completedDate = new Date(enrolment.dateCompleted);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        subtitle += ` on ${completedDate.toDateString()}`;
                    }
                }
                break;

            case 'cancelled':
                subtitle = 'Cancelled';
                break;

            default:
                break;

        }
    }

    const canRetake = !!enrolment.canRetake || course.visibility === 'public';
    const showScore = score > 0 || (!!modules && !!modules.find(({ requirement }) => requirement > 0));
    const showHistory = (!!subscription && !!subscription.userId && !!subscription.moduleId && subscription.moduleType === 'e-learning');
    const allowSwitch = showHistory && enrolment.status === 'enrolled';
    return  (
        <Card className="cent-card" key="enrolmentSegment">
            <CardHeader
                title="Enrolment"
                subtitle={subtitle}
                avatar={canRetake ? (<PublicIcon {...iconProps} />) : (<PrivateIcon {...iconProps} />)}
            />
            { showScore && (
                <CardText className="cent-card-text">
                    <Total key="score" amount={score} symbol="" title="score" />
                </CardText>
            )}
            {!!actions && (
                <CardActions className="cent-card-actions">
                    {actions}
                </CardActions>
            )}
            {allowSwitch && (
                <CardText className="cent-card-text">
                    <RegistrationHistory {...subscription} allowSwitch={allowSwitch} />
                </CardText>
            )}
        </Card>
    );
};

EnrolmentSegment.propTypes = {
    course: PropTypes.shape({
        views: PropTypes.number,
        skillId: PropTypes.number,
        visibility: PropTypes.string,
    }).isRequired,
    enrolment: PropTypes.object.isRequired,
    subscription: PropTypes.shape({
        moduleId: PropTypes.number,
        userId: PropTypes.number,
        expiry: PropTypes.object,
        moduleType: PropTypes.string
    }),
    modules: PropTypes.arrayOf(
        PropTypes.shape({requirement: PropTypes.number.isRequired})
    ),
    actions: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default EnrolmentSegment;
